import { render, staticRenderFns } from "./Остатки по поставщикам.vue?vue&type=template&id=d3b30eae&scoped=true"
import script from "./Остатки по поставщикам.vue?vue&type=script&lang=js"
export * from "./Остатки по поставщикам.vue?vue&type=script&lang=js"
import style0 from "./Остатки по поставщикам.vue?vue&type=style&index=0&id=d3b30eae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b30eae",
  null
  
)

export default component.exports